import { Segmented } from '@/components';
import { useSearchHistory } from '@/features/project/_hooks/search-projects/local-storage';
import { t } from '@/i18n';
import { useNavigate } from 'react-router';
import { z } from 'zod';

const projectsSegment = z.enum(['project', 'group']);
const projectsSegmentLabelModifier = {
  project: t('project'),
  group: t('project-group-list'),
} as const satisfies Record<z.infer<typeof projectsSegment>, string>;

const options = projectsSegment.options.map((value) => ({
  label: projectsSegmentLabelModifier[value],
  value,
}));

type Props = {
  segment: z.infer<typeof projectsSegment>;
};

export const SegmentSwitcher = ({ segment }: Props) => {
  const navigate = useNavigate();
  const { lastSearched, lastSearchedQueryParams } = useSearchHistory();
  const projectFiscalYear = lastSearched?.fiscalYear;
  return (
    <div>
      <Segmented
        value={segment}
        onChange={(value) => {
          navigate(
            value === 'project'
              ? `/rs/project?${lastSearchedQueryParams.toString()}`
              : `/rs/project/group${
                  projectFiscalYear ? `?fiscalYear=${projectFiscalYear}` : ''
                }`,
            {
              replace: true,
            },
          );
        }}
        options={options}
      />
    </div>
  );
};
